export default __webpack_public_path__ + "static/media/tokiKitSelection@2x.6cfdaa3f.png";